import React, { useState } from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';

import { useRouterParam } from 'core/router/router';
import { useAction, useActionDispatchOnMount } from 'core/store/store';

import { makeCatalogDeleteProductAction, makeCatalogSubmitProductAction } from 'state/catalog/actions';

import { AddProductForm } from 'forms/AddProductForm/AddProductForm';

import { ProductDto } from 'types';
import { DialogNew } from '../../components/Dialog/DialogNew';

export interface CatalogEditDialogProps {
    onClose: () => void;
    // Optional
    isVendor?: boolean;
}

export const CatalogEditDialog = (props: CatalogEditDialogProps) => {
    const { onClose, isVendor } = props;
    const action = useAction();
    const categoryId = useRouterParam('categoryId');
    const productId = useRouterParam('productId');
    const { t } = i18n.useTranslation();
    useActionDispatchOnMount(
        true,
        (categoryId: string, productId: string) => ({
            type: 'catalog/FETCH_PRODUCT',
            payload: { categoryId, productId },
        }),
        categoryId,
        productId,
    );
    const product: ProductDto = useSelector((state: any) => state.catalog.product);
    const currentProduct = product && product.productId === productId ? product : null;
    const formInitialValues = currentProduct
        ? {
              ...currentProduct,
              category: currentProduct.category.name,
              unit: currentProduct.unitType,
              images: product.images,
          }
        : null;

    const [coverImageCrop, setCoverImageCrop] = useState(null);

    return (
        <DialogNew disableContentPadding title={t('onboarding:card.editTitle')} onClose={onClose}>
            {formInitialValues && (
                <AddProductForm
                    initialValues={formInitialValues}
                    isEditable={true}
                    onChangeCoverImageCrop={setCoverImageCrop}
                    onDelete={() => {
                        action(makeCatalogDeleteProductAction, categoryId, productId, isVendor);
                    }}
                    onClose={onClose}
                    onSubmit={(data: any) => {
                        action(
                            makeCatalogSubmitProductAction,
                            { ...data, coverImageCrop },
                            isVendor,
                            categoryId,
                            productId,
                        );
                    }}
                />
            )}
        </DialogNew>
    );
};
